module.exports = __webpack_public_path__ + "img/kabanas.7f0577b2.jpg";